import React from 'react';
import { LoanDocumentDashboard } from './pages/LoanDocumentDashboard';
export function App() {
  return <LoanDocumentDashboard data-id="element-0" />;
}